import { render, staticRenderFns } from "./ProcessEditForm.vue?vue&type=template&id=65c8e567&"
import script from "./ProcessEditForm.vue?vue&type=script&lang=js&"
export * from "./ProcessEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports